module.exports = __webpack_public_path__ + "img/Feature.ff8503ba.jpg";